import * as Administration from '../../modules/administration'
import * as Common from '../../modules/common'
import * as Deliveries from '../../modules/deliveries'
import * as Logistics from '../../modules/logistics'
import * as Manager from '../../modules/manager'
import * as Products from '../../modules/products'
import * as Purchases from '../../modules/purchases'
import * as Sales from '../../modules/sales'
import * as Stock from '../../modules/stock'
import * as System from '../../modules/system'
import * as UI from '../../features/ui'
import { AdministrationState, AdministrationUpdateAction, AdministrationRemoveAction } from '../../modules/administration'
import { LogisticsState, LogisticsUpdateAction, LogisticsRemoveAction } from '../../modules/logistics'
import { ManagerRemoveAction, ManagerState, ManagerUpdateAction } from '../../modules/manager'
import { ProductsState, ProductsUpdateAction, ProductsRemoveAction } from '../../modules/products'
import { PurchasesState, PurchasesUpdateAction, PurchasesRemoveAction } from '../../modules/purchases'
import { SalesRemoveAction, SalesState, SalesUpdateAction } from '../../modules/sales'
import { StockState, StockUpdateAction, StockRemoveAction } from '../../modules/stock'
import { SystemState, SystemUpdateAction } from '../../modules/system'
import { DeliveriesState, DeliveriesRemoveAction, DeliveriesUpdateAction } from '../../modules/deliveries'
import { UIState } from '../../features/ui'

export enum ReducerName {
    ADMINISTRATION_REDUCER = 'administrationReducer',
    COMMON_REDUCER = 'commonReducer',
    DELIVERIES_REDUCER = 'deliveriesReducer',
    LOGISTICS_REDUCER = 'logisticsReducer',
    MANAGER_REDUCER = 'managerReducer',
    PRODUCTS_REDUCER = 'productsReducer',
    PURCHASES_REDUCER = 'purchasesReducer',
    SALES_REDUCER = 'salesReducer',
    STOCK_REDUCER = 'stockReducer',
    SYSTEM_REDUCER = 'systemReducer',
    UI_REDUCER = 'uiReducer'
}

export type ReducerStateActions = 
    typeof Administration.actionCreators |
    typeof Common.actionCreators |
    typeof Deliveries.actionCreators |
    typeof Logistics.actionCreators |
    typeof Manager.actionCreators |
    typeof Products.actionCreators |    
    typeof Purchases.actionCreators |
    typeof Sales.actionCreators |
    typeof Stock.actionCreators |
    typeof System.actionCreators |
    typeof UI.actionCreators |
    null

export type ReducerState =
    AdministrationState |
    Common.CommonState |
    DeliveriesState |
    LogisticsState |
    ManagerState |
    ProductsState |
    PurchasesState |
    SalesState |
    StockState |
    SystemState |
    UIState |
    undefined

export type ReducerStates = {
    administrationReducer: ReducerState,
    commonReducer: ReducerState,
    deliveriesReducer: ReducerState,
    logisticsReducer: ReducerState,
    managerReducer: ReducerState,
    productsReducer: ReducerState,
    purchasesReducer: ReducerState,
    salesReducer: ReducerState,
    stockReducer: ReducerState,
    systemReducer: ReducerState,
    uiReducer: ReducerState
}

export enum QueryOperator {
    AND,
    OR
}

export type Params = {
    [key: string]: string | boolean | string[]
}

export type RangeParams = {
    [key: string]: {
        start: string
        end: string
    }
}

export type Query = {
    operator?: QueryOperator,
    params: Params
}

export type UpdateAction = 
    AdministrationUpdateAction |
    DeliveriesUpdateAction |
    LogisticsUpdateAction |
    ManagerUpdateAction |
    ProductsUpdateAction |
    PurchasesUpdateAction |
    SalesUpdateAction |
    StockUpdateAction |
    SystemUpdateAction

export type RemoveAction = 
    AdministrationRemoveAction |
    DeliveriesRemoveAction |
    LogisticsRemoveAction |
    ManagerRemoveAction |
    ProductsRemoveAction |    
    PurchasesRemoveAction |
    SalesRemoveAction |
    StockRemoveAction
